export default __webpack_public_path__ + "static/media/cloudy-sun.b57804db.svg";